import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Header from './components/persistent/Header/Header';
import s from './styles/pageModules/app.module.scss';
import { ReactPressVars } from './types';
interface Props {
    root: HTMLElement;
    wpdata: ReactPressVars;
}
function App({ root, wpdata }: Props) {
    const location = useLocation();
    const navigate = useNavigate();
    useEffect(() => {
        if (location.pathname === '/') {
            navigate('/exersizes');
        }
    }, [location]);
    return (
        <main className={`fc_js-c ${s.app}`}>
            <Header root={root} wpdata={wpdata} />

            <Outlet />
        </main>
    );
}

export default App;
